/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { filterCampusVirtual, requestGetAllCampus } from "services/general";
import { throwError } from "services/helpers";
import { 
    requestGetResourceTypes, 
    requestGetElectronicBrands, 
    requestGetScreenList, 
    requestGetLibraries,
    requestGetLibraryReasonsForPenalize
} from "services/resources/library/relatedToLibraryResources";
import { requestGetBlockList, requestGetPenalties } from "services/resources/relatedToResources";
//#endregion

const useDataRelatedToLibraryResources = ({
    loadingRequest
}) => {
    //#region States
    const [resourceTypes, setResourceTypes] = useState([]);
    const [campusList, setCampusList] = useState([]);
    const [libraryList, setLibraryList] = useState([]); 
    const [electronicBrands, setElectronicBrands] = useState([]);
    const [screenList, setScreenList] = useState([]);
    const [fatalError, setFatalError] = useState(false);
    const [reasonsForPenalize, setReasonsForPenalize] = useState([]);
    const [penalties, setPenalties] = useState([]);
    const [blockList, setBlockList] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        loadingRequest.show();
        Promise.all([
            fillResourceTypes(),
            fillCampusList(),
            fillLibraryList(),
            fillElectronicBrands(),
            fillScreenList(),
            fillReasonsForPenalize(),
            fillPenalties(),
            fillBlockList()
        ])
        .catch(() => setFatalError(true))
        .finally(() => {
            loadingRequest.hide();
        });
    }, []);
    //#endregion
    //#region Functions
    const fillResourceTypes = async () => {
        const fetchData = await requestGetResourceTypes();
        throwError(fetchData);
        setResourceTypes(fetchData);
    }
    const fillCampusList = async () => {
        const fetchData = await requestGetAllCampus();
        throwError(fetchData);
        setCampusList(filterCampusVirtual(fetchData));
    }
    const fillLibraryList = async () => {
        const fetchData = await requestGetLibraries();
        throwError(fetchData);
        setLibraryList(fetchData);
    }
    const fillElectronicBrands = async () => {
        const fetchData = await requestGetElectronicBrands();
        throwError(fetchData);
        setElectronicBrands(fetchData);
    }
    const fillScreenList = async () => {
        const fetchData = await requestGetScreenList();
        throwError(fetchData);
        setScreenList(fetchData);
    }
    const fillReasonsForPenalize = async () => {
        const fetchData = await requestGetLibraryReasonsForPenalize();
        throwError(fetchData);
        setReasonsForPenalize(fetchData);
    }
    const fillPenalties = async () => {
        const fetchData = await requestGetPenalties();
        throwError(fetchData);
        setPenalties(fetchData);
    }
    const fillBlockList = async () => {
        const fetchData = await requestGetBlockList();
        throwError(fetchData);
        setBlockList(fetchData);
    }
    //#endregion
    return {
        data: {
            resourceTypes,
            campusList,
            libraryList,
            electronicBrands,
            screenList,
            reasonsForPenalize,
            penalties,
            blockList
        },
        fatalError
    };
}

export default useDataRelatedToLibraryResources;